import { useEffect, useState } from 'react'

function fmt(d: Date): string {
  const pad = (n: number) => n.toString().padStart(2, '0')
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

/** Returns a HH:MM:SS string that re-renders every `intervalMs` (default 30s). */
export function useLiveClock(intervalMs = 30_000): string {
  const [now, setNow] = useState(() => fmt(new Date()))
  useEffect(() => {
    const id = setInterval(() => setNow(fmt(new Date())), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
